import { Card, CardBody, Col } from "reactstrap";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { H6, LI, P, UL } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

//MODALS
import CreateActivityModal from "../../UiKits/Modal/Applicants/CreateActivityModal";

//TYPE
import { ApplicantActivity } from "../../../Types/Applicants/ApplicantsActivity";

//SERVICES
import {
  APPLICANT_ACTIVITY_QUERY_KEY,
  applicantActivityService,
} from "../../../Services/applicantsActivityServices";

interface CandidateProfileProps {
  ApplNo: string;
}

const Timeline: React.FC<CandidateProfileProps> = ({ ApplNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal((prev) => !prev);
  const { data: activityData = [], isLoading: TimelineisFetching } = useQuery<
    ApplicantActivity[]
  >({
    queryKey: [...APPLICANT_ACTIVITY_QUERY_KEY, ApplNo],
    queryFn: () => applicantActivityService.GetByApplNo(ApplNo as string),
    select: (data) => data.filter((item) => item.status === 1),
  });

  return (
    <Col sm="12" className="notification box-col-12">
      <Card className="card-absolute dark-timeline">
        <CommonCardHeader
          headClass="bg-primary"
          tagClass="txt-light"
          icon={<i className="icofont icofont-chart-flow-alt-2 me-1"></i>}
          title={"Activity Timeline"}
        />
        <CardBody>
          <CreateActivityModal isOpen={modal} toggle={toggle} ApplNo={ApplNo} />
          <UL className="simple-list">
            {activityData?.map((item, index) => (
              <LI className="d-flex" key={index}>
                <div className={`activity-dot-${item.activity_color}`} />

                <div className="ms-3">
                  <P className="d-flex justify-content-between mb-2">
                    <span className="date-content light-background">
                      {String(index + 1).padStart(2, "0")}. {item.activity_name}
                    </span>
                  </P>

                  <H6>
                    {item.action_date}
                    <span className="dot-notification" />
                  </H6>

                  <P
                    className="f-light f-w-200 mb-0"
                    style={{
                      fontSize: "12px",
                      lineHeight: 1,
                      letterSpacing: "0.5px",
                    }}
                  >
                    {item.action_by_user && (
                      <>
                        <b>Action By:</b> {item.action_by_user}
                        <br />
                        <br />
                      </>
                    )}
                    {item.description}
                    <br />
                    {item.note && (
                      <>
                        <b>Note:</b> {item.note}
                        <br />
                      </>
                    )}
                  </P>

                  <br />
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Timeline;
